import React from "react";
import MobileRecording from "./mobileRecording";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileContinueButton from "../button/mobileContinueButton";
import MobileCancelButton from "../button/mobileCancelButton";
import Input from "../../common/input";
import DatePicker from "../../common.old/datePicker";
import TimeKeeper from "../../common.old/timeKeeper";
import {dateToString, stringToDate} from "../../../services/dateTimeFormat";

class MobileRecordingHtmlInputField extends MobileRecording {
    constructor(props) {
        super();
    }

    handleChange = ({currentTarget: input}) => {
        // const errors = { ...this.state.errors };
        // const errorMessage = this.validateProperty(input);
        // if (errorMessage) errors[input.name] = errorMessage;
        // else delete errors[input.name];
        //
        // const data = { ...this.state.data };
        // // data[e.currentTarget.name] = e.currentTarget.value;
        // data[input.name] = input.value;
        // this.setState({ data, errors });

        const {source} = this.props;

        let displayValue = input.value;

        switch (source) {
            case "HtmlInputField-date":
                displayValue = dateToString(
                    stringToDate(input.value, "YYYY-MM-DD"),
                    "DD.MM.YYYY"
                );
                break;
            case "HtmlInputField-datetime":
                displayValue = dateToString(
                    stringToDate(input.value, "YYYY-MM-DDTHH:mm"),
                    "DD.MM.YYYY HH:mm"
                );
                break;
            // case "HtmlInputField-number":
            //   break;
            // case "HtmlInputField-time":
            //   break;
            // case "HtmlInputField-text":
            default:
        }

        this.onHtmlInputChange(input.value, displayValue);
    };

    renderDatePicker(configuration) {
        // diese Funktion wird schon beim Rendern ohne Daten aufgerufen
        // da jedoch useState nur 1 mal aufgerufen wird, darf TimeKeeper ohne Daten nicht gerendert werden

        const {data} = this.state;

        return (
            data &&
            configuration.name &&
            data[configuration.name] && (
                <DatePicker
                    name={configuration.name}
                    label={configuration.label ? configuration.label : ""}
                    value={data[configuration.name]}
                    // error={errors[configuration.name]}
                    onSimpleChange={this.simpleHandleChange}
                    help={configuration.help ? configuration.help : null}
                    // autoFocus={configuration.autofocus ? configuration.autofocus : null}
                    disabled={configuration.disabled ? configuration.disabled : null}
                />

                //   <DatePicker
                //     name={configuration.name}
                //     label={configuration.label ? configuration.label : ""}
                //     value={recordData.fields[currentRecordingFlowChart.tableField]}
                //     // error={errors[configuration.name]}
                //     //xxx onSimpleChange={this.simpleHandleChange}
                //     onSimpleChange={this.handleChange}
                //     help={configuration.help ? configuration.help : null}
                //     // autoFocus={configuration.autofocus ? configuration.autofocus : null}
                //     disabled={configuration.disabled ? configuration.disabled : null}
                //   />
            )
        );
    }

    renderTimeKeeper(configuration) {
        // diese Funktion wird schon beim Rendern ohne Daten aufgerufen
        // da jedoch useState nur 1 mal aufgerufen wird, darf TimeKeeper ohne Daten nicht gerendert werden

        const {data} = this.state;

        return (
            data &&
            configuration.name &&
            data[configuration.name] && (
                <TimeKeeper
                    name={configuration.name}
                    label={configuration.label ? configuration.label : ""}
                    value={data[configuration.name]}
                    // error={errors[configuration.name]}
                    onSimpleChange={this.simpleHandleChange}
                    help={configuration.help ? configuration.help : null}
                    // autoFocus={configuration.autofocus ? configuration.autofocus : null}
                    // disabled={configuration.disabled ? configuration.disabled : null}
                />

                //   <TimeKeeper
                //     name={configuration.name}
                //     label={configuration.label ? configuration.label : ""}
                //     //xxx value={recordData.fields[currentRecordingFlowChart.tableField]}
                //     // error={errors[configuration.name]}
                //     //xxx onSimpleChange={this.simpleHandleChange}
                //     onSimpleChange={this.handleChange}
                //     help={configuration.help ? configuration.help : null}
                //     // autoFocus={configuration.autofocus ? configuration.autofocus : null}
                //     // disabled={configuration.disabled ? configuration.disabled : null}
                //   />
            )
        );
    }

    render = () => {
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            recordData,
            source
        } = this.props;

        const continueButtonDisabled = this.isContinueButtonDisabled(
            currentRecordingFlowChart,
            recordData
        );
        // const selectionDisabled = this.isSelectionDisabled(
        //   currentRecordingFlowChart,
        //   recordData
        // );

        let configuration = {
            type: "",
            value: recordData.fields[currentRecordingFlowChart.tableField],
            error: "",
            name: "name",
            label: null,
            autofocus: true
        };

        const headerRecordDataValue =
            recordData.fields[`${currentRecordingFlowChart.tableField}Display`];
        switch (source) {
            case "HtmlInputField-date":
                configuration.type = "date";
                break;
            case "HtmlInputField-datetime":
                configuration.type = "datetime-local";
                break;
            case "HtmlInputField-number":
                configuration.type = "number";
                break;
            case "HtmlInputField-time":
                configuration.type = "time";
                break;
            case "HtmlInputField-text":
            default:
                configuration.type = "text";
        }

        return (
            <React.Fragment>
                <MobileRecordingHeader
                    title={currentFlowChart.title.text}
                    subTitle={
                        currentRecordingFlowChart.title.text + ": " + headerRecordDataValue
                    }
                />
                <Input
                    type={configuration.type}
                    name={configuration.name}
                    label={configuration.label ? configuration.label : ""}
                    value={configuration.value}
                    error={configuration.error}
                    onChange={this.handleChange}
                    help={configuration.help ? configuration.help : null}
                    autoFocus={configuration.autofocus ? configuration.autofocus : null}
                    disabled={configuration.disabled ? configuration.disabled : null}
                />
                <div
                    className="btn-toolbar justify-content-between"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                >
                    <MobileContinueButton
                        onClick={() => {
                            this.onFieldContinue();
                        }}
                        disabled={continueButtonDisabled}
                        title={{text: "Weiter"}}
                    />
                    <MobileCancelButton
                        onClick={() => {
                            this.onFieldCancel();
                        }}
                        title={{text: "Abbrechen"}}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default MobileRecordingHtmlInputField;
